import type { StructuredContentDocument } from '@repo/supergraph-schemas/structuredContent/types';
import { Categories, type Category } from './Categories';

export type Props = StructuredContentDocument<{
  items: Category[];
  overallRating?: number;
}>;

export function StarRatingCategories({ props }: Props) {
  return <Categories items={props.items} overallRating={props.overallRating} />;
}
